(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/tur/ball/assets/javascripts/constants.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.helpers = svs.tur.ball.helpers || {};
svs.tur.ball.constants = svs.tur.ball.constants || {};

svs.tur.ball.constants.BALL_REMOVED = 'ball:removed';
svs.tur.ball.constants.BALL_DELETED = 'ball:deleted';
svs.tur.ball.constants.BALL_UPDATED = 'ball:updated';

svs.tur.ball.constants.HUXFLUX_STARTED = 'huxflux:started';
svs.tur.ball.constants.HUXFLUX_COMPLETED = 'huxflux:completed';
svs.tur.ball.constants.HUXFLUX_PROGRESS = 'huxflux:progress';

svs.tur.ball.constants.ROW_ACTIVE = 'row:active';
svs.tur.ball.constants.ROW_INACTIVE = 'row:inactive';
svs.tur.ball.constants.ROW_NUMBER_UPDATED = 'row:ball:updated';
svs.tur.ball.constants.ROW_CORRECTION_COMPLETED = 'row:correction:completed';
svs.tur.ball.constants.ROW_KUNGKENO_UPDATED = 'row:kungkeno:updated';

svs.tur.ball.constants.ANIMATION_ALMOST_DONE = 'animation:almost:done';
svs.tur.ball.constants.ANIMATION_COMPLETED = 'animation:completed';
svs.tur.ball.constants.ANIMATE_IN_COMPLETED = 'animate:in:completed';

svs.tur.ball.constants.BALL_RESULT_REVEALED = 'ball:result:revealed';
svs.tur.ball.constants.RESULT_REVEALED = 'result:revealed';
svs.tur.ball.constants.RESULT_STARTED = 'result:started';
svs.tur.ball.constants.RESULT_COMPLETED = 'result:completed';
svs.tur.ball.constants.RESULT_SKIPPED = 'result:skipped';
svs.tur.ball.constants.RESULT_RENDERED = 'result:rendered';
svs.tur.ball.constants.CORRECTION_EVENT = 'correction:event';
svs.tur.ball.constants.RESULT_KUNGKENO_STARTED = 'result:kungkeno:started';
svs.tur.ball.constants.RESULT_KUNGKENO_REVEALED = 'result:kungkeno:revealed';
svs.tur.ball.constants.CORRECTION_PAUSE = 'correction:pause';
svs.tur.ball.constants.CORRECTION_PLAY = 'correction:play';

svs.tur.ball.constants.SORT_NUMERICAL = 'sort:numerical';
svs.tur.ball.constants.SORT_COMPLETED = 'sort:completed';

svs.tur.ball.constants.COLLAPSE_COMPLETED = 'collapsible:collapsed';
svs.tur.ball.constants.EXPAND_COMPLETED = 'collapsible:expanded';

 })(window);